import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, MailIcon, AlertTriangleIcon } from 'lucide-react';
export function ClassProcedures() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1472">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1473">
        <div className="mb-12" data-id="element-1474">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1475">
            Class Procedures
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1476">
            <div className="space-y-5" data-id="element-1477">
              <div className="flex items-start gap-4" data-id="element-1478">
                <ShieldCheckIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-1479" />
                <p className="text-base text-gray-800 leading-relaxed" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1480">
                  Students will be required to bring their own gun. If borrowing
                  a gun, it must be transported by the owner or a CPL holder.
                </p>
              </div>

              <div className="flex items-start gap-4" data-id="element-1481">
                <MailIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-1482" />
                <p className="text-base text-gray-800 leading-relaxed" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1483">
                  Should you not have a pistol, email{' '}
                  <a href="mailto:FLSCGunTeacher@FentonLakes.com" className="font-semibold hover:underline" style={{
                  color: '#1e3d2f'
                }} data-id="element-1484">
                    FLSCGunTeacher@FentonLakes.com
                  </a>{' '}
                  and we will attempt to provide a loaner pistol for the class.
                </p>
              </div>

              <div className="flex items-start gap-4" data-id="element-1485">
                <ShieldCheckIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-1486" />
                <p className="text-base text-gray-800 leading-relaxed" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1487">
                  Guns and ammunition are to be kept locked up in your car until
                  required by the instructor.
                </p>
              </div>

              <div className="flex items-start gap-4 p-4 rounded-lg" style={{
              backgroundColor: '#fffbeb',
              border: '1px solid #c8a84b'
            }} data-id="element-1488">
                <AlertTriangleIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#c8a84b'
              }} data-id="element-1489" />
                <p className="text-base text-gray-800 leading-relaxed" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1490">
                  Bring a minimum of <strong data-id="element-1491">100 rounds</strong>. Magnum rounds
                  are <strong data-id="element-1492">not allowed</strong> on the indoor range! Please
                  review the{' '}
                  <Link to="/range-rules" className="font-semibold hover:underline" style={{
                  color: '#1e3d2f'
                }} data-id="element-1493">
                    FLSC Range Rules
                  </Link>{' '}
                  for allowed calibers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}